import { SupportOptionsTypes } from "types";

const loadOptions = () => {
	try {
		const options = SupportOptionsTypes.getOptions();

		return {
			options,
			hasMore: false,
		};
	} catch {
		return { options: [] };
	}
};

const supportOptionsColumn = () => ({
	name: "agentOfficePackage",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Office Responsibility",
});

export default supportOptionsColumn;
